import type { Filter } from '@fabric-ui/components';
import { filterLeaves } from './filter-leaves';
import { compareFieldname } from './filter-utils';

export const removeByField = (source: Filter, targetField: string): Filter | null =>
  filterLeaves(source, leaf => compareFieldname(leaf, targetField));
